/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Ikhgeo6Inputs */

const en__field_enum_ikhgeo6 = /** @type {(inputs: _Field_Enum_Ikhgeo6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`11 - Geowissenschaften / Geographie`)
};

const de__field_enum_ikhgeo6 = /** @type {(inputs: _Field_Enum_Ikhgeo6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`11 - Geowissenschaften / Geographie`)
};

/**
* | output |
* | --- |
* | "11 - Geowissenschaften / Geographie" |
*
* @param {_Field_Enum_Ikhgeo6Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_ikhgeo6 = /** @type {((inputs?: _Field_Enum_Ikhgeo6Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Ikhgeo6Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_ikhgeo6(inputs)
	return de__field_enum_ikhgeo6(inputs)
});
export { _field_enum_ikhgeo6 as "_field_enum_IKHGEO" }